<script lang="ts">
import FichePaieViewer from '@/generated/fiches/FichePaieViewer.vue';
import { defineComponent } from "vue";

export default defineComponent({
  components: {},
  extends: FichePaieViewer
})

</script>
